/** Response header Cloudflare sets when it mitigates a request; `challenge` marks a managed challenge. */
// KEEP_IN_SYNC weavy/core/src/shared/config/consts.ts (Consts.CF_MITIGATED_HEADER_NAME)
export const CF_MITIGATED_HEADER = 'cf-mitigated';

/** The `cf-mitigated` value marking a managed/interactive challenge (edge-generated; no core mirror). */
export const CF_MITIGATED_CHALLENGE_VALUE = 'challenge';

/** Turnstile `action` the invisible pre-clearance widget renders with; must match the action configured on the Cloudflare pre-clearance rule. */
export const WAF_CHALLENGE_ACTION = 'waf_clearance';

// Trimmed so a whitespace-only env value reads as empty, i.e. no sitekey provisioned and recovery off.
export const getWAFTurnstileSitekey = (): string => (import.meta.env.VITE_WAF_TURNSTILE_SITE_KEY ?? '').trim();

/** Whether a Turnstile sitekey is provisioned; without one no solve can run and recovery stays off. */
export const hasWAFTurnstileSitekey = (): boolean => getWAFTurnstileSitekey().length !== 0;

/** Test id for the invisible WAF pre-clearance widget, distinct from the sign-in widget's default. */
export const WAF_CLEARANCE_WIDGET_TEST_ID = 'waf-clearance-turnstile-widget';
